import { ref } from 'vue'

import type { RoomId } from '@/types'

import storage from './useLastRooms.storage'

const LIMIT = 10

const lastRooms = ref<RoomId[]>(storage.get() ?? [])

function add(id: RoomId) {
  if (lastRooms.value.includes(id)) {
    lastRooms.value = lastRooms.value.filter((i) => i !== id)
    lastRooms.value.unshift(id)
    storage.set(lastRooms.value)
    return
  }
  if (lastRooms.value.length === LIMIT) {
    lastRooms.value.pop()
  }
  lastRooms.value.unshift(id)
  storage.set(lastRooms.value)
}

export default function useLastRooms() {
  return {
    lastRooms,
    add,
  }
}
